<template>
  <b-container
    class="mb-5"
    fluid
  >
    <div class="d-flex justify-content-end mb-0 pb-0">
      <b-breadcrumb
        v-if="$route.meta.breadcrumb"
        :items="$route.meta.breadcrumb || []"
      />
    </div>
    <b-container fluid>
      <b-row>
        <b-col
          cols="12"
          md="10"
          class="px-1"
          order="2"
          order-md="1"
        >
          <b-form-group
            label="Search"
            label-for="filter_search"
            label-class="font-weight-bolder"
          >
            <b-input
              id="filter_search"
              v-model="tableQRPh.filter.search"
              type="text"
              size="sm"
              placeholder="search here"
              debounce="1000"
              autocomplete="off"
            />
          </b-form-group>
        </b-col>
        <b-col
          cols="12"
          md="2"
          class="px-1"
          order="1"
          order-md="2"
        >
          <b-form-group
            label="Status"
            label-for="filter_status"
            label-class="font-weight-bolder"
          >
            <b-form-select
              id="filter_status"
              v-model="tableQRPh.filter.status"
              size="sm"
              :options="tableQRPh.filterOptions.statuses"
            >
              <template #first>
                <b-form-select-option
                  :value="null"
                  disabled
                >
                  -- select status here --
                </b-form-select-option>
              </template>
            </b-form-select>
          </b-form-group>
        </b-col>
      </b-row>

      <b-row class="mt-1">
        <b-col
          cols="12"
          class="px-1"
        >
          <b-table
            ref="tableQRPh"
            hover
            small
            striped
            bordered
            responsive
            show-empty
            :stacked="isMobile()"
            :per-page="tableQRPh.perPage"
            :current-page="tableQRPh.currentPage"
            :items="tableQRPhProvider"
            :fields="tableQRPh.fields"
            :sort-by.sync="tableQRPh.sortBy"
            :sort-desc.sync="tableQRPh.sortDesc"
            :sort-direction="tableQRPh.sortDirection"
            :filter="tableQRPh.filter"
            :filter-included-fields="tableQRPh.filterOn"
            :busy="tableQRPh.busy"
          >
            <template #cell(index)="row">
              {{ tableQRPh.currentPage * tableQRPh.perPage - tableQRPh.perPage + (row.index + 1) }}
            </template>

            <template #cell()="row">
              <div class="text-wrap text-md-nowrap">
                {{ row.value }}
              </div>
            </template>

            <template #cell(active)="row">
              {{ Number(row.value) === 1 ? 'Yes' : 'No' }}
            </template>

            <template #cell(amount)="row">
              <div
                class="text-md-nowrap text-right"
                style="min-width: 100px !important;"
              >
                {{ row.value }}
              </div>
            </template>

            <template #cell(action)="row">
              <div class="text-md-nowrap d-flex flex-column flex-md-row justify-content-center">
                <b-button
                  v-if="row.item.webhook"
                  size="sm"
                  :variant="row.detailsShowing ? 'danger' : 'primary' "
                  @click="row.toggleDetails"
                >
                  {{ row.detailsShowing ? 'Hide' : 'Show' }} Webhook
                </b-button>
              </div>
            </template>

            <template #row-details="{ item }">
              <b-form-group
                label="Payload"
                label-class="font-weight-bolder"
                class="mb-2 px-5"
              >
                <vue-json-pretty
                  :data="item.webhook"
                />
              </b-form-group>
            </template>

            <template #table-busy>
              <div class="text-center py-5">
                <b-icon
                  icon="stopwatch"
                  font-scale="5"
                  animation="cylon"
                />
                <p class="h3 py-2">
                  <strong>Loading . . .</strong>
                </p>
              </div>
            </template>

          </b-table>
        </b-col>

        <b-col
          cols="12"
          md="6"
          class="mt-1 mb-2 px-1"
        >
          <b-select
            v-model="tableQRPh.perPage"
            :options="tableQRPh.pageOptions"
            size="sm"
            class="w-100 w-md-25"
          />
        </b-col>
        <b-col
          cols="12"
          md="6"
          class="d-flex justify-content-center justify-content-md-end mt-1 px-1"
        >
          <b-pagination
            v-model="tableQRPh.currentPage"
            pills
            last-number
            first-number
            prev-text="Prev"
            next-text="Next"
            aria-controls="table"
            :total-rows="tableQRPh.totalRows"
            :per-page="tableQRPh.perPage"
          />
        </b-col>
      </b-row>
    </b-container>
  </b-container>
</template>

<script>
// import QUERY from 'lodash'
import { core } from '@/config/pluginInit'
import { SAdminReport } from '@/services'
import formatter from '@/mixins/formatter'
import Ripple from 'vue-ripple-directive'
import misc from '@/mixins/misc'

export default {
  name: 'AdminReportsQRPh',

  middleware: ['auth', 'admin'],

  directives: {
    Ripple
  },

  mixins: [misc, formatter],

  metaInfo: () => ({
    title: 'QRPh'
  }),

  data () {
    return {
      state: {
        busy: false,
        editing: false
      },
      tableQRPh: {
        perPage: 10,
        pageOptions: [10, 25, 50, 100],
        totalRows: 0,
        currentPage: 1,
        sortBy: null,
        sortDesc: false,
        sortDirection: 'asc',
        filter: {
          search: null,
          status: 'All'
        },
        filterOn: [],
        filterOptions: {
          statuses: ['All', 'Pending', 'Failed', 'Rejected']
        },
        busy: false,
        fields: [
          { mobile: 0, key: 'index', label: '#', class: 'text-center' },
          { mobile: 12, key: 'action', class: 'text-center min-w-150px' },
          { mobile: 1, key: 'created_at', class: 'min-w-200px', formatter: this.dateTimeFormatter, sortable: true },
          { mobile: 2, key: 'user.organization', label: 'Organization', class: 'min-w-250px' },
          { mobile: 3, key: 'partner_reference', class: 'min-w-350px' },
          { mobile: 4, key: 'provider_reference', class: 'min-w-350px' },
          { mobile: 5, key: 'external_reference', class: 'min-w-350px' },
          { mobile: 6, key: 'merc_token', class: 'min-w-150px' },
          { mobile: 7, key: 'terminal_id', class: 'text-center' },
          { mobile: 8, key: 'amount', class: 'min-w-150px', formatter: this.numberFormatter },
          { mobile: 9, key: 'status', class: 'text-center min-w-100px' },
          { mobile: 10, key: 'paid_at', class: 'min-w-200px', formatter: this.dateTimeFormatter, sortable: true },
          { mobile: 11, key: 'tag', class: 'text-center min-w-100px' }
        ].sort(this.scaleOnMobile)
      }
    }
  },

  mounted () {
    core.index()
  },

  methods: {

    async tableQRPhProvider ({ currentPage, perPage, sortBy, sortDesc, filter }) {
      this.tableQRPh.busy = true
      return await SAdminReport.getQRPh(
        this.objectToUrl({
          page: currentPage,
          per_page: perPage,
          sort: sortBy,
          sort_desc: sortDesc,
          filter_text: filter.search,
          filter_status: filter.status
        })
      ).then(({ data }) => {
        this.tableQRPh.totalRows = data.total_rows
        return data.items
      }).catch(() => []).finally(() => {
        this.tableQRPh.busy = false
      })
    }
  }
}
</script>
